import { List, Typography } from 'antd';

const { Text } = Typography;

const CancellationAndReturn = () => {

  const cancellationRateDesc = [
    'Hiç bir ürün toplanamadığı için tüm siparişin iptal olması.',
    'Backoffice üzerinden manuel iptal edilmesi.',
    'Müşterinin siparişi tamamen iptal etmesi',
    'Tüm siparişin teslimat aşamasında ‘Teslim Edilemedi’ yapılması.'
  ];

  const returnRateDesc = [
    'Teslimat aşamasında kapıda en az 1 ürünün iade alınmış olması.',
    'Tam teslim edilmiş olsa dahi marketten en az 1 ürünün iade edilmesi.'
  ];

  return (<List
    className="demo-loadmore-list"
    itemLayout="horizontal"
  >
    <List.Item.Meta
      style={{ marginBottom: 10 }}
    />
    <Text strong style={{ fontSize: 16 }}>
      <p>İptal Oranı </p>
      İlgili dağıtım tarihine ait siparişlerin ne kadarının iptal edildiğini gösteren orandır.
      Diğer başlıkların aksine bu oranın hedef değerinden daha düşük olması beklenir. Bu
      yüzden hedeften daha düşükse yeşil, yüksekse kırmızı gösterilir.
      <p>Sipariş aşağıdaki durumlardan en az 1 tanesini içeriyor ise bu orana yansır:</p>
    </Text>
    <ul>
      {cancellationRateDesc.map((item, index) => (<li style={{ color: '#555555', fontWeight: 500 }} key={index}>{item}</li>))}
    </ul>
    <Text strong style={{ fontSize: 16 }}>
      <p>İade Oranı</p>
      İlgili dağıtım tarihine ait siparişlerin ne kadarında iade olduğunu gösteren orandır.
      Diğer başlıkların aksine bu oranın hedef değerinden daha düşük olması beklenir. Bu
      yüzden hedeften daha düşükse yeşil, yüksekse kırmızı gösterilir.
      <p>Sipariş aşağıdaki durumlardan en az 1 tanesini içeriyor ise bu orana yansır:</p>
    </Text>
    <ul>
      {returnRateDesc.map((item, index) => (<li style={{ color: '#555555', fontWeight: 500 }} key={index}>{item}</li>))}
    </ul>
  </List>);
};

export default CancellationAndReturn;
